import Vue from 'vue';
import {
  Icon,
  Toast,
  Dialog,
  Tab,
  Tabs,
  AddressEdit,
  Form,
  Button,
  Field,
  Popup,
  Divider,
  Area,
  Switch,
  Step,
  Steps,
  List,
  SwipeCell,
  Loading,
  PullRefresh,
  Swipe,
  SwipeItem,
  Rate,
  Overlay,
  Skeleton,
  Popover,
  Uploader,
  ImagePreview,
  Picker,
  Image as VanImage,
  CountDown,
} from 'vant';

Vue
  .use(Icon)
  .use(Toast)
  .use(Dialog)
  .use(Tab)
  .use(Tabs)
  .use(AddressEdit)
  .use(Form)
  .use(Button)
  .use(Field)
  .use(Popup)
  .use(Area)
  .use(Switch)
  .use(Step)
  .use(Steps)
  .use(List)
  .use(Popover)
  .use(SwipeCell)
  .use(Loading)
  .use(PullRefresh)
  .use(Swipe)
  .use(SwipeItem)
  .use(Overlay)
  .use(Skeleton)
  .use(Rate)
  .use(Uploader)
  .use(ImagePreview)
  .use(Picker)
  .use(VanImage)
  .use(Divider)
  .use(CountDown);
